<template>
  <v-card>

    <v-progress-circular v-if="loading"
                         indeterminate
                         color="primary">
    </v-progress-circular>

    <v-card-text>
    <service-request-properties-view v-if="serviceRequest != null"
                                     :service-request="serviceRequest">
      <template v-slot:append>
        <entity-properties-row>
          <v-btn v-if="$featurePermissions.serviceRequestCRUD"
                 tile
                 color="primary"
                 @click="openEditDialog">
            {{ $t('actions.modify') }}
            <v-icon right dark>
              mdi-border-color
            </v-icon>
          </v-btn>
        </entity-properties-row>
      </template>
    </service-request-properties-view>
    <service-request-dialog ref="serviceRequestDialog" @done="reload"/>
    </v-card-text>
  </v-card>
</template>

<script>
import Vue from 'vue';
import EntityPropertiesRow from '@/components/entity-crud/EntyPropertiesRow';
import ServiceRequestPropertiesView from '@/views/servicerequest/ServiceRequestPropertiesView';
import ServiceRequestDialog from '@/views/servicerequest/ServiceRequestDialog';
import ServiceRequestsService from '@/services/ServiceRequestsService';

export default Vue.extend({
  name: 'ServiceRequestDetails',
  components: {
    ServiceRequestDialog,
    ServiceRequestPropertiesView,
    EntityPropertiesRow,
  },
  data() {
    return {
      serviceRequest: null,
      loading: false,
    };
  },
  mounted() {
    this.reload();
  },
  methods: {
    reload() {
      this.loading = true;
      ServiceRequestsService.get(this.serviceRequestId).then(result => {
        this.serviceRequest = result.data;
      }).catch(err => {
        console.log(JSON.stringify(err));
      }).finally(() => {
        this.loading = false;
      });
    },

    openEditDialog() {
      this.$refs.serviceRequestDialog.openEditForServiceRequest(this.serviceRequestId);
    },
  },

  computed: {
    serviceRequestId() {
      return parseInt(this.$route.params.id, 10);
    },
  },
});
</script>
